<template>
    <div class="form-add-client">
        <div class="form-add-client__title">
            Создание среза
        </div>
        <div class="form-add-client__input">
          <button
              v-for="(itemKey, index) in Object.keys(yearList)"
              :key="index"
              class="filer-control-dropdown__menu-item"
              :class="{'filer-control-dropdown__menu-item_active': itemKey === selectedYear}"
              @click="onChangeYear(itemKey)"
          >
                    <span>
                        {{itemKey}} год
                    </span>
          </button>
        </div>
        <div class="form-add-client__btn-container">
            <button class="form-add-client__button" @click="onClickCancel">Отмена</button>
            <button
                class="form-add-client__button form-add-client__action-button"
                v-if="selectedYear"
                type="submit"
                @click="onClickSubmit"
            >
                Создать
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormCreateSlice',
    beforeMount() {
      this.selectedYear = String(this.getCurrentYear());
    },
    /**
     * данные компонента
     */
    data: () => ({
      selectedYear: null,
    }),
    computed:{
      /**
       * Получение значений годов для выпадашки
       */
      yearList(){
        var cur_year = this.getCurrentYear();
        let years = {};
        years[String(cur_year - 2)] = String(cur_year - 2);
        years[String(cur_year - 1)] = String(cur_year - 1);
        years[String(cur_year)] = String(cur_year);
        years[String(cur_year + 1)] = String(cur_year + 1);
        // years[String(cur_year + 1)] = String(cur_year + 1);
        return years
      },
    },
    methods: {
        getCurrentYear(){
          var now = new Date();
          return now.getFullYear();
        },
        /**
         * событие изменения значения чекбокса
         */
        onChangeYear(data){
            this.selectedYear = data;
        },
        /**
         * событие отправки имени новой группы
         */
        onClickSubmit() {
            this.$emit('submitForm', this.selectedYear);
        },
        onClickCancel(){
            this.$emit('cancelForm');
        }
    }
}
</script>

<style lang="scss" scoped>
    .form-add-client {
        height: 270px;
    }
    .form-add-client__title {
        text-align: center;
        font-size: 20px;
        margin: 20px 20px 20px 20px;
    }
    .form-add-client__input {
        width: 200px;
        text-align: center;
        margin: 20px 20px 20px 20px;
        border: 1px solid #dbdbdb;
        border-radius: 10px;
    }
    .form-add-client__input input {
        width: 100%;
    }
    .form-add-client__btn-container {
        width: 200px;
        text-align: end;
        margin: 20px 20px 20px 20px;
        bottom: 10px;
        right: 10px;
        position: absolute;
    }
    .form-add-client__button{
        cursor: pointer;
        pointer-events: auto;
        height: 32px;
        width: min-content;
        padding: 4px 14px;
        border-radius: 100px;
        transition: 0.3s;
        border: 1px solid transparent;
        outline: none;
    }
    .form-add-client__action-button{
        margin-left: 5px;
        color: #000;
        background: #fe1060;
    }
    .filer-control-dropdown__menu-item {
      position: relative;
      display: flex;
      white-space: nowrap;
      line-height: 1;
      align-items: center;
      color: #222;
      transition: all 150ms;
      cursor: pointer;
      border: 0;
      background: none;
      text-align: left;
      overflow: visible;
      font: inherit;
      font-size: 18px;
      outline: 0;
      width: 100%;
      text-overflow: ellipsis;
      padding: 5px 15px;
      justify-content: space-between;
    }
    .filer-control-dropdown__menu-item:hover {
      color: #fe1060;
    }
    .filer-control-dropdown__menu-item_active {
      color: #fe1060;
    }
    .filer-control-dropdown__menu-item-icon {
      color: #fe1060;
      font-size: .6154rem;
    }
</style>